import React, { memo } from "react";
import {
  Slider,
  Typography,
  Grid,
  TextField,
  InputAdornment,
} from "@mui/material";
import { formatAmount } from "../../utils/helpers";
export const formatWithCommas = (value) => {
  if (value === null || value === undefined) return "";
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatNumber = (value) => {
  if (value >= 1e9) {
    return `${(value / 1e9).toFixed(1).replace(/\.0$/, "")} Billion +`;
  }

  if (value >= 1e6) {
    return `${(value / 1e6).toFixed(1).replace(/\.0$/, "")} Million`;
  }

  if (value >= 1e3) {
    return `${(value / 1e3).toFixed(1).replace(/\.0$/, "")} K`;
  }

  return formatWithCommas(value);
};

const revenueSteps = [
  0, 100000, 200000, 500000, 1000000, 2000000, 5000000, 10000000, 20000000,
  30000000, 50000000, 60000000, 70000000, 80000000, 90000000, 100000000,
  200000000, 300000000, 400000000, 500000000, 600000000, 700000000, 800000000,
  900000000, 1000000000, 2000000000, 5000000000,
];

const getRevenueLabel = (value) => formatNumber(revenueSteps[value]);

export const RevenueSlider = ({ values, onChange }) => {
  return (
    <>
      <Typography
        variant="body1"
        color="primary"
        fontSize={"14px"}
        gutterBottom
      >
        Business Revenue Experience
      </Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Slider
            value={[
              revenueSteps.indexOf(values.business_revenue_from),
              revenueSteps.indexOf(values.business_revenue_to),
            ]}
            onChange={(event, newValue) => {
              onChange(revenueSteps[newValue[0]], revenueSteps[newValue[1]]);
            }}
            valueLabelDisplay="auto"
            min={0}
            max={revenueSteps?.length - 1}
            valueLabelFormat={(value) => getRevenueLabel(value)}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent={"space-between"}
      >
        <Grid item xs={6} md={3}>
          <TextField
            label="From"
            value={getRevenueLabel(
              revenueSteps.indexOf(values.business_revenue_from)
            )}
            InputProps={{
              readOnly: true,
              inputProps: {
                style: {
                  height: "7px",
                  fontSize: "12px",
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <TextField
            label="To"
            value={getRevenueLabel(
              revenueSteps.indexOf(values.business_revenue_to)
            )}
            InputProps={{
              readOnly: true,
              inputProps: {
                style: {
                  height: "7px",
                  fontSize: "12px",
                },
              },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export const CompensationSlider = memo(
  ({
    label,
    fromField,
    toField,
    formik,
    min = 0,
    max = 5000000000,
    step = 100000,
    onChange,
    disabled = false,
  }) => {
    const handleSliderChange = (event, newValue) => {
      formik.setFieldValue(fromField, newValue[0]);
      formik.setFieldValue(toField, newValue[1]);
    };
    const handleNumberInput = (field, value) => {
      let numericalValue = value.replace(/[^\d]/g, "");
      if (numericalValue > max) numericalValue = max;
      formik.setFieldValue(field, Number(numericalValue));
    };
    return (
      <>
        <Typography
          variant="body1"
          color="primary"
          fontSize={"14px"}
          gutterBottom
        >
          {label}
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <Slider
              value={[formik.values[fromField], formik.values[toField]]}
              onChange={onChange || handleSliderChange}
              valueLabelDisplay="auto"
              min={min}
              max={max}
              step={step}
              valueLabelFormat={(value) => formatNumber(value)}
              disabled={disabled}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent={"space-between"}
        >
          <Grid item xs={6} md={3}>
            <TextField
              disabled={disabled}
              label="From"
              value={formatWithCommas(formik.values[fromField])}
              onChange={(e) => handleNumberInput(fromField, e.target.value)}
              error={Boolean(formik.errors[fromField])}
              helperText={formik.errors[fromField]}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
                inputProps: {
                  style: {
                    height: "7px",
                    fontSize: "12px",
                  },
                },
              }}
              placeholder="From"
            />
          </Grid>

          <Grid item xs={6} md={3}>
            <TextField
              label="To"
              disabled={disabled}
              value={formatWithCommas(formik.values[toField])}
              onChange={(e) => handleNumberInput(toField, e.target.value)}
              error={Boolean(formik.errors[toField])}
              helperText={formik.errors[toField]}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
                inputProps: {
                  style: {
                    height: "7px",
                    fontSize: "12px",
                  },
                },
              }}
              placeholder="To"
            />
          </Grid>
        </Grid>
      </>
    );
  }
);
